<template>
	<div class="settings-container">
		<h1>{{ $t('appbar.settings-menu.Contacts.title') }}</h1>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
.settings-container {
	flex: 1;
	overflow-y: auto;
	padding: 1rem;
}

.settings-container::after {
	content: '';
	display: block;
	height: 2rem;
	width: 100%;
}

.profile-photo {
	position: relative;
	border: 1px solid #323232;
	cursor: pointer;
	height: 150px;
	width: 150px;
}

.tan-icon-arrow-up {
	position: absolute;
	right: 5px;
	bottom: 5px;
}

.profile-photo-input {
	display: none;
}
</style>